import clsx from "clsx";
import styles from "./PaginationButton.module.scss";

const PaginationButton = ({
    onClick,
    title,
    disabled,
}: {
    onClick: () => void;
    disabled?: boolean;
    title: string;
}) => {
    return (
        <button
            className={clsx(styles.container, {
                [styles.disabled]: !!disabled,
            })}
            onClick={onClick}>
            {title}
        </button>
    );
};

export default PaginationButton;
